/**
 * @author:panshuwei
 * @date:2018-08-12
 * @description:
 *
 * isDebug:输出日志设置为1，不输出日志设置为0
 */

const config = {
  version: '0.1.5',
  isDebug: 0,
  app_title: '',
  pageSizeOptions: ['10', '20', '50'],
  pageSize: 10,
};

export default config;



// WEBPACK FOOTER //
// ./src/base/config.js